import { Link2Off } from 'lucide-react';
import { Button } from '~/components/ui/button';
import { StatusCard } from '~/components/StatusCard';

function LinkReplaced({ schoolName }: { schoolName: string }) {
  return (
    <StatusCard icon={<Link2Off className="h-5 w-5" />} title="This link has been replaced">
      <p className="text-muted-foreground">
        {schoolName} now handles enrollment in SolaStack and will email you a new invitation.
      </p>
      <div className="flex items-center gap-3">
        <span className="text-sm">Already have an account?</span>
        <Button asChild variant="outline">
          <a href="/users/sign_in">Sign in</a>
        </Button>
      </div>
    </StatusCard>
  );
}

export default LinkReplaced;
